import { Controller } from '@hotwired/stimulus'
import Text from '../../lib/text'
import Dom from '../../lib/dom'

export default class extends Controller {
  static targets = ['name', 'number', 'expirationMonth', 'expirationYear', 'cvv', 'hash', 'tokenizerErrors']

  connect () {
    this.blockSensitiveParameters()
  }

  generate (e) {
    const form = e.currentTarget.closest('form')

    if (!this.validate()) {
      e.preventDefault()
      return
    }

    Dom.fire(e.currentTarget, 'generating', null, { bubbles: true })

    PagarmeCheckout.init(
      (data) => this.onSuccess(data),
      (error) => this.onError(error, form)
    )

    form.requestSubmit()
  }

  onSuccess (data) {
    this.hashTarget.value = data["pagarmetoken-0"]
  }

  onError (error, form) {
    this.forceSubmit(form)
  }

  validate () {
    const card = this.card

    let valid = true
    valid = valid & this.validateField('card_holder_name', card, this.nameTarget)
    valid = valid & this.validateField('card_number', card, this.numberTarget, 19)
    valid = valid & this.validateField('card_exp_month', card, this.expirationMonthTarget, 2)
    valid = valid & this.validateField('card_exp_year', card, this.expirationYearTarget, 2)
    valid = valid & this.validateField('card_cvv', card, this.cvvTarget, 3)
    return valid
  }

  validateField (key, card, input, length) {
    if (card[key] && Text.isPresent(this.card[key])) return true
    if (card[key] && length && this.card[key].length === length) return true

    input.classList.add('field_with_errors')
    input.nextElementSibling.classList.add('field_with_errors')
    return false
  }

  blockSensitiveParameters () {
    this.nameTarget.removeAttribute('name')
    this.numberTarget.removeAttribute('name')
    this.expirationMonthTarget.removeAttribute('name')
    this.expirationYearTarget.removeAttribute('name')
    this.cvvTarget.removeAttribute('name')
  }

  forceSubmit (form) {
    const clone = form.cloneNode(true)

    clone.style.display = 'none'
    clone.setAttribute('turbo', true)
    clone.removeAttribute('data-action')
    clone.querySelectorAll('[data-action]').forEach(el => {
      el.removeAttribute('data-action')
    })

    document.body.appendChild(clone)

    clone.submit()
  }

  get card () {
    return {
      card_holder_name: this.nameTarget.value,
      card_number: this.numberTarget.value,
      card_exp_month: this.expirationMonthTarget.value,
      card_exp_year: this.expirationYearTarget.value,
      card_cvv: this.cvvTarget.value
    }
  }
}
